module.exports = __webpack_public_path__ + "static/img/top_ly2.67fa3f2b.png";